module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"shared":{"global":{"minutes":{"abbr":{"one":"1 min","other":"%{count} min"}}}}}}}')
  delete Component.options._Ctor
}
